import { Injectable } from '@angular/core';
import { combineLatest, map, Observable, of } from 'rxjs';
import { TranslationService } from '../../../../core/i18n';
import { Cart, CartError, CartErrorContext } from '../../../../core/model';
import { CartAccountingCodesFacade } from '../facades';
import { CartValidatorFacade } from '../facades/cart-validator.facade';

@Injectable()
export class CartValidatorService implements CartValidatorFacade {
  constructor(
    private cartAccountingCodesService: CartAccountingCodesFacade,
    private translationService: TranslationService
  ) {}

  getCartErrors(cart: Cart): Observable<CartError[] | null> {
    return combineLatest([this.cartAccountingCodesService.getCartAccountingCodeErrors(cart)]).pipe(
      map(([accountingCodeErrors]) => {
        return [...(accountingCodeErrors ?? [])];
      }),
      map((errors) => (errors?.length > 0 ? errors : null))
    );
  }

  getCartErrorMessage(cartErrors: CartError[] | null): Observable<string | null> {
    if (this.hasError(cartErrors, CartErrorContext.ACCOUNTING_CODE, 'required')) {
      return this.translationService.translate('cart.accountingCodeRequired_message');
    }
    if (this.hasError(cartErrors, CartErrorContext.ACCOUNTING_CODE, 'invalidAccountingCodeAssigned')) {
      return this.translationService.translate('cart.invalidAccountingCodeAssigned_message');
    }
    if (this.hasError(cartErrors, CartErrorContext.ACCOUNTING_CODE, 'notReinvoicingFieldValues')) {
      return this.translationService.translate('cart.invalidAccountingCodeReinvoicing_message');
    }
    return of(null);
  }

  private hasError(cartErrors: CartError[] | null, context: CartErrorContext, errorKey: string): boolean {
    if (!cartErrors) {
      return false;
    }

    return cartErrors.some((cartError) => cartError.context === context && !!cartError.error && errorKey in cartError.error);
  }
}
